import { Directive } from "vue";
import {
  PermissionString,
  userHasPermission,
} from "@/composables/user-permissions.ts";

export const UserCanDirective: Directive<HTMLElement, PermissionString> = (
  el: HTMLElement,
  { value },
) => {
  if (!userHasPermission(value)) {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};
